
export class FileUploadRequestDto {
  file: any;
}
